import { FormControlLabel, Radio } from '@material-ui/core';
import React from 'react';


const RadioButton = ({
	value,
	checked,
	label,
	disabled,
	name,
	onChange,
	styleLabel,
}) => (
	<FormControlLabel
		control={
			<Radio
				disabled={disabled}
				checked={checked}
				onChange={onChange}
				value={`${value}`}
				// value={'' + value}
				name={name}
			/>
		}
		style={{ ...styleLabel }}
		label={label}
	/>
);

export default RadioButton;
